<template>
  <DialogDrawer ref="dialog" modal placement="centre" @close="$emit('close')">
    <template #title> {{ isUpdateForm ? 'Update' : 'Create' }} {{ type }} </template>
    <Transition>
      <div v-if="open">
        <RadioButtonGroup
          v-if="isUpdateForm === false"
          id="category-dialog-controller"
          v-model="selectedOption"
          class="w-100 mb-3"
          :options="createOptions"
        />
        <CategoriesForm
          :is-update-form="isUpdateForm"
          :cid="cid"
          :type="type"
          :selected-option="selectedOption"
          @close="$emit('close')"
          @submit="$emit('submit')"
        />
      </div>
    </Transition>
  </DialogDrawer>
</template>
<script lang="ts" setup>
import DialogDrawer from '@/components/shared/custom/DialogDrawer/DialogDrawer.vue';

const props = defineProps<{
  isUpdateForm: boolean;
  type?: string;
  cid?: number;
  open: boolean;
}>();

defineEmits<{
  (event: 'close'): void;
  (event: 'submit'): void;
}>();

const dialog = useTemplateRef<InstanceType<typeof DialogDrawer>>('dialog');

watch(
  () => props.open,
  (newOpen) => {
    if (newOpen) {
      dialog.value?.openModal();
    } else {
      dialog.value?.close();
    }
  },
);

const createOptions = ref(['Category', 'Sub-Category', 'Group']);
const selectedOption = ref();

onMounted(() => {
  selectedOption.value = props.type || createOptions.value[0];
});

onUpdated(() => {
  // Used when the dialog opens or closes
  selectedOption.value = props.type || createOptions.value[0];
});
</script>
<style lang="scss" scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
